<stages-responsive-data-view
	#dataView
	[dataSource]="dataSource"
	[listItemTemplate]="listItemTemplate"
	[idFn]="FilesNotificationsComponent.getUserId"
	[idFnNew]="FilesNotificationsComponent.getUserTypedId"
	[disabledFn]="FilesNotificationsComponent.isDisabled"
	[disabledFnNew]="FilesNotificationsComponent.isSelectable"
	[isPreselectedFn]="FilesNotificationsComponent.isPreselected"
	[showSelectDeselectButtons]="true"
	[mode]="mode"
	[storeIdentifier]="storeIdentifierAssociatedUsers"
	[translateNone]="'files.notification.noAssociations'"
/>

<ng-template #listItemTemplate let-user>
	<div class="label">
		<div class="avatar-cell-48">
			<stages-user-image
				[userName]="user.fullname"
				[userId]="user.id"
				[version]="user.profileImageVersion"
			></stages-user-image>
		</div>
		<div class="text center list-users">
			<span class="h4">
				<span>{{ user.username }} ({{ user.fullname }})</span>
			</span>
			@if (user.emailAddress === null) {
				<p class="warning-color" translate="files.notification.no.email"></p>
			}
			<p class="overflow" title="{{ user.roles.join(', ') }}" translate="files.notification.user.details.roles">
				<span class="overflow"> {{ user.roles.join(", ") }}</span>
			</p>
		</div>
	</div>
</ng-template>
